import ViewEditInstantLuckyDrawDialog from './viewEditInstantLuckyDrawDialog.container'

export default ViewEditInstantLuckyDrawDialog